import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import Styles from "./NotPastTripPopup.module.scss";

type Props = {
  isNotPastTrip: boolean;
  handleCancelNotPastTripModal: () => void;
  handleContinueNotPastTripModal: () => void;
};

const NotPastTripPopup: React.FC<Props> = ({
  isNotPastTrip,
  handleCancelNotPastTripModal,
  handleContinueNotPastTripModal,
}) => {
  return (
    <Modal
      onOk={handleCancelNotPastTripModal}
      onCancel={handleCancelNotPastTripModal}
      visible={isNotPastTrip}
      className={Styles.NotPastTripModalContainer}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      centered={true}
      footer={
        <Row className={Styles.modalContainer}>
          <Col span={24}>
            <Row justify="center">
              <Typography.Text className={Styles.modalHeader}>
                Trip in the past
              </Typography.Text>
            </Row>
            <Row
              justify="center"
              className={`${Styles.notPastTripSection} ${Styles.description}`}
            >
              <Col>
                <p className={`${Styles.modalBodyText} ${Styles.description}`}>
                  The selected date and time are in the past for this service
                  area.
                </p>
              </Col>
            </Row>
            <Row justify="center" className={Styles.notPastTripSection}>
              <Col>
                <p
                  className={`${Styles.modalBodyText} ${Styles.subDescription}`}
                >
                  Please review the selected date and time for this trip.
                </p>
              </Col>
            </Row>
            <Row justify="center" className={Styles.notPastTripSection}>
              <Col className={Styles.modalBtn}>
                <Space>
                  <Button
                    className={Styles.buttonTheme}
                    onClick={handleCancelNotPastTripModal}
                  >
                    Close
                  </Button>

                  <Button
                    className={Styles.buttonThemeBlue}
                    onClick={handleContinueNotPastTripModal}
                  >
                    Confirm
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};

export default NotPastTripPopup;
